import React, { useState, useEffect } from "react";
import { Breadcrumb, Table } from "antd";
import Loader from "../../components/loader/loader";
import { addIcon, editIcon, homeIcon, redTrash } from "../../assets";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import { useNavigate } from "react-router-dom";
import { GreenNotify } from "../../helper/helper";
import DeleteModal from "../../components/deleteModal/DeleteModal";

const EmployerCard = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [employerCards, setEmployerCards] = useState([]);
  const [getServiceapi, setGetServiceApi] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const getAllEmployerCards = () => {
    let getRes = (res) => {
      console.log("res of getAllEmployers", res);
      setEmployerCards(res?.data?.data);
    };

    callApi(
      "GET",
      routes.getAllEmployerCards,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  const handleDeleteClick = (card) => {
    setSelectedCard(card);
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirm = () => {
    if (selectedCard?._id) {
      deleteEmployer(selectedCard._id);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setSelectedCard(null);
  };

  const deleteEmployer = (id) => {
    setGetServiceApi(false);
    let getRes = (res) => {
      console.log("res of deleteEmployerCard", res);
      GreenNotify("Employer card is deleted successfully");
      setGetServiceApi(true);
      setDeleteModalVisible(false);
      setSelectedCard(null);
    };

    callApi(
      "DELETE",
      `${routes.deleteEmployerCard}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
        setDeleteModalVisible(false);
        setSelectedCard(null);
      }
    );
  };

  useEffect(() => {
    getAllEmployerCards();
  }, [getServiceapi]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      className: "role-name-column-header",
      align: "center",
    },

    {
      title: "Edit",
      dataIndex: "edit",
      align: "center",
      className: "action-column-header",
      width: 400,
    },
    {
      title: "Delete",
      dataIndex: "delete",
      align: "center",
      className: "action-column-header",
    },
  ];

  const data = employerCards?.map((item, index) => {
    return {
      key: index,
      name: item?.name,
      quote: item?.quote,
      edit: (
        <div
          onClick={() =>
            navigate("/editEmployerCard", { state: { item: item } })
          }
          style={{ cursor: "pointer" }}
        >
          <img
            style={{ width: "3rem", height: "3rem" }}
            src={editIcon}
            alt="editIcon"
          />
        </div>
      ),
      delete: (
        <div
          onClick={() => handleDeleteClick(item)}
          style={{ cursor: "pointer" }}
        >
          <img src={redTrash} alt="red-trash" />
        </div>
      ),
    };
  });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />
      <DeleteModal
        visible={deleteModalVisible}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        title="Delete Employer Card"
        message="Are you sure you want to delete employer card"
        itemName={selectedCard?.name}
        isLoading={isloading}
      />
      <Breadcrumb
        separator=">"
        className="bread-crumb"
        items={[
          {
            title: (
              <span className="configure-server-home-icon">
                <img
                  style={{ width: "1.7rem", height: "1.7rem" }}
                  src={homeIcon}
                  alt="home-icon"
                />
              </span>
            ),
          },
          { title: "Employer Card" },
        ]}
      />
      <div className="configure-server-roles-main-heading-container">
        <h1>Employer Card</h1>
        <div
          onClick={() => navigate("/addEmployerCard")}
          className="server-roles-add-btn"
          style={{ backgroundColor: "#23252f" }}
        >
          <img src={addIcon} alt="" />
          <p>Add New</p>
        </div>
      </div>
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={{ pageSize: 5 }}
        ></Table>
      </div>
    </div>
  );
};

export default EmployerCard;
